var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$store.state.dingding === 'dingtalk' && _vm.isSpecialData.projectStr)?void 0:_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }